import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export const minLengthValidator =
    (minLength: number, message: string): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
        const validationErrors = Validators.minLength(minLength)(control);
        if (validationErrors) {
            return {
                minLength: message
            };
        }
        return null;
    };
